module.exports = __webpack_public_path__ + "img/a3d545b.jpg";